import { useQuery } from "@tanstack/react-query";
import { wishlistApi } from "@/lib/wishlist-api";

export const wishlistQueryKeys = {
  all: ["wishlists"] as const,
  lists: () => [...wishlistQueryKeys.all, "list"] as const,
  list: (customerId: string) => [...wishlistQueryKeys.lists(), customerId] as const,
};

export const useWishlistsQuery = (customerId: string) => {
  return useQuery({
    queryKey: wishlistQueryKeys.list(customerId),
    queryFn: () => wishlistApi.fetchLists(customerId),
    enabled: !!customerId,
    staleTime: 5 * 60 * 1000,
  });
};
